import { Text } from '../../text';
import { TextProps } from '../../text';
import { Label } from '../atoms/label.component';
import { getInlineLabelClassName } from './inline-label.styles';
import type { InlineLabelPlacement } from './types';

type Props = {
  children: React.ReactNode;
  id: string;
  disabled?: boolean;
  placement?: InlineLabelPlacement;
  color?: TextProps['color'];
};

export const InlineLabel = ({ children, id, disabled = false, placement = 'right', color = 'default' }: Props) => {
  return (
    <Text id={id} className={getInlineLabelClassName({ disabled, placement })} as={Label} color={color}>
      {children}
    </Text>
  );
};
